import _defineProperty from "/home/runner/work/design/design/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var TEXT_ROW_HEIGHT = '20px'; // custom value off the scale

export var getVariantStyles = function getVariantStyles() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  var theme = arguments.length > 1 ? arguments[1] : undefined;
  var style = {
    default: {
      color: 'btn.text',
      backgroundColor: 'btn.bg',
      boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.shadow, ", ").concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.insetShadow),
      '&:hover:not([disabled])': {
        backgroundColor: 'btn.hoverBg'
      },
      '&:active:not([disabled])': {
        backgroundColor: 'btn.activeBg',
        borderColor: 'btn.activeBorder'
      },
      '&:disabled': {
        color: 'primer.fg.disabled',
        '[data-component=ButtonCounter]': {
          color: 'inherit'
        }
      },
      '&[aria-expanded=true]': {
        backgroundColor: 'btn.activeBg',
        borderColor: 'btn.activeBorder'
      }
    },
    primary: {
      color: 'btn.primary.text',
      backgroundColor: 'btn.primary.bg',
      borderColor: 'border.subtle',
      boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.primary.shadow),
      '&:hover:not([disabled])': {
        color: 'btn.primary.hoverText',
        backgroundColor: 'btn.primary.hoverBg'
      },
      '&:focus:not([disabled])': {
        boxShadow: 'inset 0 0 0 3px'
      },
      '&:focus-visible:not([disabled])': {
        boxShadow: 'inset 0 0 0 3px'
      },
      '&:active:not([disabled])': {
        backgroundColor: 'btn.primary.selectedBg',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.primary.selectedShadow)
      },
      '&:disabled': {
        color: 'btn.primary.disabledText',
        backgroundColor: 'btn.primary.disabledBg',
        '[data-component=ButtonCounter]': {
          color: 'inherit'
        }
      },
      '[data-component=ButtonCounter]': {
        backgroundColor: 'btn.primary.counterBg',
        color: 'btn.primary.text'
      },
      '&[aria-expanded=true]': {
        backgroundColor: 'btn.primary.selectedBg',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.primary.selectedShadow)
      }
    },
    danger: {
      color: 'btn.danger.text',
      backgroundColor: 'btn.bg',
      boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.shadow),
      '&:hover:not([disabled])': {
        color: 'btn.danger.hoverText',
        backgroundColor: 'btn.danger.hoverBg',
        borderColor: 'btn.danger.hoverBorder',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.danger.hoverShadow),
        '[data-component=ButtonCounter]': {
          backgroundColor: 'btn.danger.hoverCounterBg',
          color: 'btn.danger.hoverText'
        }
      },
      '&:active:not([disabled])': {
        color: 'btn.danger.selectedText',
        backgroundColor: 'btn.danger.selectedBg',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.danger.selectedShadow),
        borderColor: 'btn.danger.selectedBorder'
      },
      '&:disabled': {
        color: 'btn.danger.disabledText',
        backgroundColor: 'btn.danger.disabledBg',
        borderColor: 'btn.danger.disabledBorder',
        '[data-component=ButtonCounter]': {
          color: 'inherit',
          backgroundColor: 'btn.danger.disabledCounterBg'
        }
      },
      '[data-component=ButtonCounter]': {
        color: 'btn.danger.text',
        backgroundColor: 'btn.danger.counterBg'
      },
      '&[aria-expanded=true]': {
        color: 'btn.danger.selectedText',
        backgroundColor: 'btn.danger.selectedBg',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.danger.selectedShadow),
        borderColor: 'btn.danger.selectedBorder'
      }
    },
    invisible: {
      color: 'accent.fg',
      backgroundColor: 'transparent',
      border: '0',
      boxShadow: 'none',
      '&:hover:not([disabled])': {
        backgroundColor: 'btn.hoverBg'
      },
      '&:active:not([disabled])': {
        backgroundColor: 'btn.selectedBg'
      },
      '&:disabled': {
        color: 'primer.fg.disabled',
        '[data-component=ButtonCounter]': {
          color: 'inherit'
        }
      },
      '&[aria-expanded=true]': {
        backgroundColor: 'btn.selectedBg'
      }
    },
    outline: {
      color: 'btn.outline.text',
      boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.shadow),
      borderColor: 'btn.border',
      backgroundColor: 'btn.bg',
      '&:hover:not([disabled])': {
        color: 'btn.outline.hoverText',
        backgroundColor: 'btn.outline.hoverBg',
        borderColor: 'outline.hoverBorder',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.outline.hoverShadow),
        '[data-component=ButtonCounter]': {
          backgroundColor: 'btn.outline.hoverCounterBg',
          color: 'inherit'
        }
      },
      '&:active:not([disabled])': {
        color: 'btn.outline.selectedText',
        backgroundColor: 'btn.outline.selectedBg',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.outline.selectedShadow),
        borderColor: 'btn.outline.selectedBorder'
      },
      '&:disabled': {
        color: 'btn.outline.disabledText',
        backgroundColor: 'btn.outline.disabledBg',
        borderColor: 'btn.border',
        '[data-component=ButtonCounter]': {
          backgroundColor: 'btn.outline.disabledCounterBg',
          color: 'inherit'
        }
      },
      '[data-component=ButtonCounter]': {
        backgroundColor: 'btn.outline.counterBg',
        color: 'btn.outline.text'
      },
      '&[aria-expanded=true]': {
        color: 'btn.outline.selectedText',
        backgroundColor: 'btn.outline.selectedBg',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.outline.selectedShadow),
        borderColor: 'btn.outline.selectedBorder'
      }
    }
  };
  return style[variant];
};
/* The button heights have to amount to 
  small - 28
  medium - 32
  large - 34
  In icon these have to be square.
*/

export var getSizeStyles = function getSizeStyles() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medium';
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var iconOnly = arguments.length > 2 ? arguments[2] : undefined;
  var paddingY, paddingX, fontSize;

  switch (size) {
    case 'small':
      paddingY = 3;
      paddingX = 12;
      fontSize = 0;
      break;

    case 'large':
      paddingY = 9;
      paddingX = 20;
      fontSize = 2;
      break;

    case 'medium':
    default:
      paddingY = 5;
      paddingX = 16;
      fontSize = 1;
  }

  if (iconOnly) {
    // when `size !== 'medium'`, vertical alignment of the icon is thrown off
    // because changing the font size draws an em-box that does not match the
    // bounding box of the SVG
    fontSize = 1;
    paddingX = paddingY + 3; // to make it a square
  }

  if (variant === 'invisible') {
    paddingY = paddingY + 1; // to make up for absence of border
  }

  return {
    paddingY: "".concat(paddingY, "px"),
    paddingX: "".concat(paddingX, "px"),
    fontSize: fontSize,
    '[data-component=ButtonCounter]': {
      fontSize: fontSize
    }
  };
};
export var getBaseStyles = function getBaseStyles(theme) {
  return {
    borderRadius: '2',
    border: '1px solid',
    borderColor: theme === null || theme === void 0 ? void 0 : theme.colors.btn.border,
    fontFamily: 'inherit',
    fontWeight: 'bold',
    lineHeight: TEXT_ROW_HEIGHT,
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    cursor: 'pointer',
    appearance: 'none',
    userSelect: 'none',
    textDecoration: 'none',
    textAlign: 'center',
    '&:disabled': {
      cursor: 'default'
    },
    '&:disabled svg': {
      opacity: '0.6'
    },
    '@media (forced-colors: active)': {
      '&:focus': {
        // Support for Windows high contrast https://sarahmhigley.com/writing/whcm-quick-tips
        outline: 'solid 1px transparent'
      }
    }
  };
};
export var getButtonStyles = function getButtonStyles(theme) {
  var styles = _objectSpread(_objectSpread({}, getBaseStyles(theme)), {}, {
    display: 'grid',
    gridTemplateAreas: '"leadingIcon text trailingIcon"',
    '& > :not(:last-child)': {
      mr: '2'
    },
    '[data-component="leadingIcon"]': {
      gridArea: 'leadingIcon'
    },
    '[data-component="text"]': {
      gridArea: 'text'
    },
    '[data-component="trailingIcon"]': {
      gridArea: 'trailingIcon'
    }
  });

  return styles;
};